import Vue from 'vue';
import VueHead from 'vue-head';
import Affix from 'vue-affix';
import VueScrollactive from 'vue-scrollactive';
import VueSimpleSVG from 'vue-simple-svg';
import Toasted from 'vue-toasted';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import VueCookies from 'vue-cookies';

import VueGtm from 'vue-gtm';
import VueGtag  from 'vue-gtag';

import App from './App.vue';
import router from './router';
import store from './store/index.js';
import iOrder from './libs/plugins/iOrder.js';
import directives from './libs/plugins/directives.js';
import filters from './libs/plugins/filters.js';
import * as validate from './libs/plugins/validate.js';

Raven
  .config('https://f78c21ee916f46c68d96270102fcd0e0@sentry.io/1449651', {
    environment: process.env.NODE_ENV
  })
  .addPlugin(RavenVue, Vue)
  .install();

Vue.config.productionTip = false;

Vue.use(VueHead);
Vue.use(Affix);
Vue.use(VueScrollactive);
Vue.use(VueSimpleSVG);
Vue.use(Toasted);
Vue.use(VueCookies);

if (process.env.NODE_ENV === 'production') {
  Vue.use(VueGtag, {
    config: {
      id: 'UA-138945382-1'
    },
    bootstrap: false,
    disableScriptLoad: false
  });
  Vue.use(VueGtm, {
    id: 'GTM-WQQ3NKP',
    enabled: false,
    compatibility: true,
    vueRouter: router
  });
}

Vue.component('v-style', {
  render: function (createElement) {
    return createElement('style', this.$slots.default)
  }
});

new Vue({
  router,
  store,
  directives,
  filters,
  iOrder,
  validate,
  beforeCreate: () => store.dispatch('initApp'),
  render: h => h(App)
}).$mount('#app');
